<template>
  <div class="afterSaleDetails-container page-container">
    <div class="afterSale-header">
      <div class="afterSale-header-logo">
        <img src="@/assets/imgs/logo.svg" alt="" />
        <h3>售后登记表</h3>
      </div>
      <!-- <button class="gb-button" @click="$router.push({ path: '/o/c' })">
        创建
      </button> -->
    </div>
    <div
      class="afterSaleDetails-form"
      v-if="(!orders || !orders.length) && !keyCode"
    >
      <div class="afterSaleDetails-code-handle-btn">
        <div class="afterSaleDetails-areaCode-warp">
          <span>+</span>
          <el-input
            class="afterSaleDetails-areaCode-input"
            v-model.trim="areaCode"
            @keyup.enter.native="checkDetails"
          ></el-input>
        </div>

        <el-input
          v-model.trim="phone"
          oninput="value=value.replace(/[^\d]/g,'')"
          class="afterSaleDetails-text-input"
          :placeholder="$t('placeholder.phone')"
          @keyup.enter.native="checkDetails"
          clearable
        ></el-input>
      </div>
      <div class="afterSaleDetails-code-handle-btn">
        <el-input
          v-model.trim="code"
          oninput="value=value.replace(/[^\d]/g,'')"
          class="afterSaleDetails-text-input"
          :placeholder="$t('placeholder.code')"
          @keyup.enter.native="checkDetails"
          clearable
        ></el-input>
        <el-button
          v-if="!isGetCode"
          class="gb-button code-btn"
          @click="getCode"
          >{{ $t("login.getCode") }}</el-button
        >
        <el-button v-else class="gb-button code-btn gb-button-disabled" disabled
          >{{ $t("common.resend") }}（{{ countdown }}）</el-button
        >
      </div>
      <!-- <p class="afterSaleDetails-form-tips font-format-small regular-family">{{$t('elMsg.tips20')}}</p> -->
      <el-button
        class="afterSaleDetails-form-btn white-color gb-button font-format-normal multiple-family"
        @click="checkDetails"
        >{{ $t("common.check") }}</el-button
      >
    </div>
    <div class="afterSaleDetails-main">
      <!-- <p class="afterSaleDetails-main-title font-format-big multiple-family">售后列表详情</p> -->
      <div class="afterSaleDetails-main-card" v-if="orders && orders.length">
        <el-table
          :data="orders"
          row-key="_id"
          :expand-row-keys="defaultExpandRowKeys"
          height="100%"
        >
          <el-table-column type="expand">
            <template slot-scope="scope">
              <el-steps :active="getStatus(scope.row)" align-center>
                <el-step
                  title="提交申请"
                  :description="getDesc(scope.row, 'apply')"
                ></el-step>
                <el-step
                  title="售后签收"
                  :description="getDesc(scope.row, 'receive')"
                ></el-step>
                <el-step
                  title="产品检测中"
                  :description="getDesc(scope.row, 'check')"
                ></el-step>
                <el-step
                  title="问题确认"
                  :description="getDesc(scope.row, 'confirm')"
                ></el-step>
                <el-step title="支付确认"></el-step>
                <el-step
                  title="维修进行中"
                  :description="getDesc(scope.row, 'repair')"
                ></el-step>
                <el-step
                  title="完结"
                  :description="getDesc(scope.row, 'end')"
                ></el-step>
              </el-steps>
            </template>
          </el-table-column>
          <el-table-column label="型号" prop="model" show-overflow-tooltip>
          </el-table-column>
          <el-table-column
            label="维修编号"
            prop="repairNumber"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column label="进度" prop="step" show-overflow-tooltip>
            <template slot-scope="scope">
              <span>{{
                scope.row.progress[scope.row.progress.length - 1].name
              }}</span>
              <!-- <span v-if="scope.row.step==='apply'">提交申请</span>
              <span v-if="scope.row.step==='receive'">售后签收</span>
              <span v-if="scope.row.step==='check'">产品检测中</span>
              <span v-if="scope.row.step==='confirm'">问题确认</span>
              <span v-if="scope.row.step==='to_be_paid'">付费维修</span>
              <span v-if="scope.row.step==='free'">免费维修</span>
              <span v-if="scope.row.step==='repair'">维修进行中</span>
              <span v-if="scope.row.step==='cancel'">用户取消支付</span>
              <span v-if="scope.row.step==='repair_finish'">维修完成，已寄出</span>
              <span v-if="scope.row.step==='cancel_finish'">取消维修，已退回</span> -->
            </template>
          </el-table-column>
          <!-- <el-table-column label="快递单"
                           prop="trackingNumber"
                           show-overflow-tooltip>
            <template slot-scope="scope">
              {{scope.row.trackingNumber ? scope.row.trackingNumber : '-'}}
            </template>
          </el-table-column> -->
          <el-table-column label="时间" prop="updatedAt" show-overflow-tooltip>
            <template slot-scope="scope">
              {{ scope.row.updatedAt | filterDate }}
            </template>
          </el-table-column>
          <el-table-column label="操作" width="130" :align="'center'">
            <template slot-scope="scope">
              <el-button type="primary" @click="updateTrackingNumber(scope.row)"
                >更新快递单号</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="afterSaleDetails-noData" v-else>
        <img src="@/assets/imgs/icon_table_no_gift.svg" alt="" />
        <p class="table-empty-msg font-format-medium regular-family">
          暂无数据
        </p>
      </div>
    </div>

    <el-dialog
      title="更新快递单号"
      :visible.sync="dialogVisible"
      width="300px"
      center
    >
      <div class="afterSaleDetails-dialog">
        <el-form
          :model="form"
          @submit.native.prevent
          label-position="left"
          ref="form"
          :rules="rules"
          :inline="false"
          size="normal"
        >
          <el-form-item label="快递单号" prop="trackingNumber">
            <el-input
              class="afterSaleDetails-form-input"
              placeholder="请输入快递单号"
              @keyup.enter.native="submitForm('form')"
              v-model.trim="form.trackingNumber"
            ></el-input>
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">{{
          $t("common.cancel")
        }}</el-button>
        <el-button type="primary" @click="submitForm('form')">{{
          $t("common.confirm")
        }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  components: {},
  computed: {
    ...mapGetters(["userInfo"]),
    rules() {
      let rules = {
        phone: [
          {
            required: true,
            message: this.$t("placeholder.phone"),
            trigger: "blur",
          },
        ],
        trackingNumber: [
          { required: true, message: "订单号不能为空", trigger: "blur" },
        ],
      };
      return rules;
    },
  },
  data() {
    return {
      phone: "",
      code: "",
      areaCode: "86",
      countdown: 60,
      isGetCode: false,
      initTime: null,
      activeNames: [],
      orders: [],
      defaultExpandRowKeys: [],
      selectOrder: null,
      dialogVisible: false,
      form: {
        trackingNumber: "",
      },
      keyCode: null,
    };
  },
  methods: {
    async getCode() {
      if (!this.checkPhoneParams()) return;
      this.countdownStart();
      this.isGetCode = true;
      let params = {
        mobi: this.phone,
      };
      try {
        await this.$http.sendMobileCode(params);
      } catch (error) {
        clearInterval(this.initTime);
        this.isGetCode = false;
        this.countdown = 60;
      }
    },

    countdownStart() {
      clearInterval(this.initTime);
      this.initTime = setInterval(() => {
        if (this.countdown === 1) {
          this.isGetCode = false;
          this.countdown = 60;
          clearInterval(this.initTime);
        } else {
          this.countdown -= 1;
        }
      }, 1000);
    },

    checkPhoneParams() {
      if (!this.phone || this.phone.indexOf(" ") !== -1) {
        this.elMsg(this.$t("elMsg.phoneEmpty"), "error");
        return false;
      }

      if (!this.areaCode || this.areaCode.indexOf(" ") !== -1) {
        this.elMsg(this.$t("elMsg.areaEmpty"), "error");
        return false;
      }

      return true;
    },

    checkCode() {
      if (!this.code || this.code.indexOf(" ") !== -1) {
        this.elMsg(this.$t("elMsg.codeEmpty"), "error");
        return false;
      }

      return true;
    },

    async checkDetails() {
      if (!this.checkPhoneParams() || !this.checkCode()) return;
      try {
        await this.login();
        await this.getWorkorders();
        this.elMsg(this.$t("elMsg.checkSuccess"), "success");
        this.code = "";
        this.phone = "";
        this.countdown = 60;
        this.isGetCode = false;
      } catch (error) {
        console.log(error);
      }
    },

    async login() {
      return new Promise(async (resolve, reject) => {
        let params = {
          area_code: `+${this.areaCode}`,
          mobi: this.phone,
          code: this.code,
        };
        try {
          let res = await this.$http.login(params);
          this.$local.set("afterSaleToken", res.data.token);
          this.$cookie.set("afterSaleToken", res.data.token);
          resolve("ok");
        } catch (error) {
          reject(error);
        }
      });
    },

    getWorkorders() {
      return new Promise(async (resolve, reject) => {
        try {
          let res = await this.$http.getWorkorders({ code: this.keyCode });
          if (!res.data.length) {
            this.elMsg("暂无数据", "warning");
            return;
          }
          this.orders = res.data;
          this.defaultExpandRowKeys = [];
          this.defaultExpandRowKeys.push(this.orders[0]._id);
          resolve("ok");
        } catch (error) {
          reject(error);
        }
      });
    },

    updateTrackingNumber(item) {
      this.selectOrder = item;
      this.dialogVisible = true;
    },

    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.updateWorkorders();
        } else {
          return false;
        }
      });
    },

    async updateWorkorders() {
      try {
        this.form.code = this.keyCode;
        await this.$http.updateWorkorders(this.selectOrder._id, this.form);
        this.getWorkorders();
        this.elMsg("订单号更新成功", "success");
        this.dialogVisible = false;
      } catch (error) {
        this.elMsg("订单号更新失败", "error");
      }
    },

    getStatus(item) {
      // apply = 提交申请
      // receive = 售后签收
      // check = 产品检测中
      // confirm = 问题确认
      // to_be_paid = 付费维修
      // free = 免费维修
      // repair = 维修进行中
      // cancel = 用户取消支付
      // repair_finish = 维修完成，已寄出
      // cancel_finish = 取消维修，已退回
      let status;
      switch (item.step) {
        case "apply":
          status = 1;
          break;
        case "receive":
          status = 2;
          break;
        case "check":
          status = 3;
          break;
        case "confirm":
          status = 4;
          break;
        case "paid":
        case "to_be_paid":
        case "free":
        case "fees_received":
          status = 5;
          break;
        case "repair":
        case "unPaid":
          status = 6;
          break;
        case "cancel":
        case "repair_finish":
        case "cancel_finish":
          status = 7;
          break;
        default:
          status = null;
          break;
      }
      return status;
    },

    getDesc(item, type) {
      if (
        (type === "end" && item.step === "repair_finish") ||
        (type === "end" && item.step === "cancel_finish")
      ) {
        return item.progress[item.progress.length - 1].desc;
      } else {
        for (let i of item.progress) {
          if (i.step === type) return i.desc;
        }
      }
    },
  },
  mounted() {
    this.keyCode = this.$route.query.s ? this.$route.query.s : null;
    if (this.keyCode) {
      this.getWorkorders();
    }
  },
};
</script>

<style lang="scss">
.afterSaleDetails-container {
  .afterSale-header {
    height: 66px;
    padding: 0 10px;
    background: #fff;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .afterSale-header-logo {
      display: flex;
      align-items: center;
      > img {
        width: 80px;
      }
    }
  }
  .afterSaleDetails-form {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 0 20px;
    overflow: hidden;
    .afterSaleDetails-code-handle-btn {
      display: flex;
      width: 100%;
      max-width: 350px;
      min-width: 150px;
      margin-top: 20px;
      overflow: hidden;
      border: 1px solid #eeeeee;
      background: $mainColor;
      border-radius: $button-radius;
      height: 40px;
      line-height: 40px;
      .afterSaleDetails-areaCode-warp {
        display: flex;
        align-items: center;
        width: 65px;
        margin-left: 10px;
        border-right: 1px solid #eeeeee;
        > span {
          /* margin-bottom: 4px; */
        }
        .afterSaleDetails-areaCode-input {
          > .el-input__inner {
            background: transparent !important;
            padding: 0 5px;
            border: 0;
          }
        }
      }
      .afterSaleDetails-text-input {
        > .el-input__inner {
          background: transparent !important;
          padding: 0 10px 0 15px;
          border: 0;
        }
      }
      .code-btn {
        height: 100%;
        background: $themeColor;
        border-radius: $button-radius;
        box-shadow: none;
      }
      .disabled-btn {
        color: #fff;
        border: 0;
        background: #d88364;
        @extend .code-btn;
      }
    }

    .afterSaleDetails-form-tips {
      margin-top: 12px;
    }

    .afterSaleDetails-form-btn {
      width: 100%;
      max-width: 350px;
      min-width: 150px;
      margin-top: 40px;
    }
  }
  .afterSaleDetails-main {
    flex: 1;
    display: flex;
    flex-direction: column;
    margin: 10px;
    overflow: hidden;
    .afterSaleDetails-noData {
      height: 100% !important;
      width: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      height: 220px;
      background: #fff;
      box-shadow: $div-shadow;
      border-radius: $button-radius;
      margin-top: 20px;

      > .table-empty-msg {
        margin-top: 15px;
        color: #595959;
      }
    }
    .afterSaleDetails-main-card {
      flex: 1;
      display: flex;
      flex-direction: column;
      overflow: hidden;
      background: #fff;
      box-shadow: $div-shadow;
      border-radius: 4px;
      margin-top: 20px;
      .el-table__expanded-cell {
        padding: 20px 10px;
        .el-step__title {
          font-size: 14px;
        }
      }
    }
  }
}
.afterSaleDetails-dialog {
  display: flex;
  overflow: hidden;
  > .el-form {
    width: 100%;
  }
  .afterSaleDetails-form-input {
    > input {
      background: $menutBGColor;
      border-radius: $button-radius;
    }
  }
}
</style>
